import { dataHooks } from '@wix/data-hooks';

export const templateMediaContainerDataHooks = dataHooks<{
  editButton: { key: string };
  viewButton: { key: string };
}>('template-media-container');
